import { Box, BoxProps } from '@mantine/core';

export const Circle: React.FC<BoxProps> = ({ children, ...props }) => (
  <Box
    sx={{
      width: '44px',
      minWidth: '44px',
      height: '44px',
      background: '#fff',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      boxShadow: '0px 1px 10px 0px rgba(30, 28, 73, 0.12);',
      borderRadius: '100%',
    }}
    {...props}
  >
    {children}
  </Box>
);
